import Big from 'big.js';
import { formatterCurrency, formatterNumber, formatterDate } from '../utils/formatter';
import { movementsTransactionStats } from '../configs/app.config';

let assets = null;

function setAssets() {
  if (!assets)
    assets = JSON.parse(localStorage.getItem("assets"));
}

export const additionalData = {
  wallet: {
    additionalColumns: (data) => {
      return {
        balanceInEur:
          data.balance !== null && data['asset.rate'] !== null && data['asset.rate.EUR'] !== null
            ? new Big(data.balance)
              .mul(data['asset.rate.EUR'])
              .toString()
            : '0',
        // availableBalanceInEur:
        //   data.availableBalance !== null && data['asset.rate.EUR'] !== null
        //     ? new Big(data.availableBalance)
        //       .mul(data['asset.rate.EUR'])
        //       .round(decimalPlaces, roundingMode)
        //       .toString() + '€'
        //     : 'N/A',
      };
    },
    additionalTable: (data) => {
      const summary = data.reduce((acc, val) => {
        const state = {
          numberOfWallets: data.length || 0,
          sumBalanceInEuros: acc.sumBalanceInEuros || 0,
          // totalAvailableBalanceInEur: acc.totalAvailableBalanceInEur || 0,
        };
        if (val.balance !== null && val['asset.rate'] !== null && val['asset.rate.EUR'] !== null)
          state.sumBalanceInEuros = new Big(val.balance)
            .mul(val['asset.rate.EUR'])
            .add(state.sumBalanceInEuros)
            .toString();

        // if (val.availableBalance !== null && val['asset.rate.EUR'] !== null)
        //   state.totalAvailableBalanceInEur = new Big(val.availableBalance)
        //     .mul(val['asset.rate.EUR'])
        //     .add(state.totalAvailableBalanceInEur)
        //     .round(decimalPlaces, roundingMode)
        //     .toString();

        return state;
      }, {});
      return {
        title: 'Page\'s Totals',
        data: [
          {
            ...summary,
            sumBalanceInEuros: formatterCurrency(summary.sumBalanceInEuros, { decimals: 2 }),
            numberOfWallets: formatterNumber(summary.numberOfWallets),
          },
        ]
      };
    },
  },

  transaction: {
    additionalColumns: (data) => {
      return {
        amountInEur:
          data.amount !== null && data['rates'] !== null && data['rates.EUR'] !== null
            ? new Big(data.amount)
              .mul(data['rates.EUR'])
            : null,
      };
    },
    additionalTable: (data) => {
      const summary = data.reduce((acc, val) => {
        const amountInEur =
          val.amount !== null && data['rates'] !== null && data['rates.EUR'] !== null
            ? new Big(val.amount)
              .mul(val['rates.EUR'])
              .toString()
            : new Big(0);

        const state = {
          numberOfTransactions: data.length || 0,
          sumAmountsInEuros: acc.sumAmountsInEuros || 0,
          numberApproved: acc.numberApproved || 0,
          numberPending: acc.numberPending || 0,
          numberRejected: acc.numberRejected || 0,
        };

        if (val.status === 'approved') state.numberApproved += 1;
        if (val.status === 'pending') state.numberPending += 1;
        if (val.status === 'rejected') state.numberRejected += 1;
        state.sumAmountsInEuros = new Big(state.sumAmountsInEuros)
          .add(amountInEur)
          .toString();

        return state;
      }, {});
      return {
        title: 'Page\'s Totals',
        data: [
          {
            ...summary,
            sumAmountsInEuros: formatterCurrency(summary.sumAmountsInEuros, { decimals: 2 }),
            numberApproved: formatterNumber(summary.numberApproved),
            numberPending: formatterNumber(summary.numberPending),
            numberRejected: formatterNumber(summary.numberRejected),
          },
        ]
      }
    },
  },

  withdrawal: {
    additionalColumns: (data) => {
      return {
        "asset.symbol": data['asset'],
      };
    },
  },

  purchase: {
    additionalColumns: (data) => {
      setAssets();

      let amountInEur = null;
      if (
        data.operation === 'sell' &&
        data.amount !== null &&
        data['rate'] !== null
      ) {
        amountInEur =
          new Big(data.amount)
            .div(new Big(data['rate']))
      }
      else if (data.operation === 'buy' && data.amount !== null) {
        amountInEur =
          new Big(data.amount);
      }
      return {
        amountInEur: amountInEur,
        userId: data['user'],
        walletId: data['wallet'],
        "assetId": data['asset'],
        "asset.symbol": assets && data['asset'] && assets[data['asset']] ? assets[data['asset'].toString()]['symbol'] : data['asset'],
      };
    },
    additionalTable: (data) => {
      const summary = data.reduce((acc, val) => {
        let amountInEur = new Big(0);
        if (
          val.operation === 'sell' &&
          val.amount !== null &&
          val.rate !== null
        )
          amountInEur = new Big(val.amount).div(new Big(val.rate));
        else if (val.operation === 'buy' && val.amount !== null)
          amountInEur = new Big(val.amount);

        // amountInEur = amountInEur.round(decimalPlaces, roundingMode).toString();

        const state = {
          numberOfPurchases: data.length || 0,
          numApprovedSells: acc.numApprovedSells || 0,
          sumApprovedSellsInEuros: acc.sumApprovedSellsInEuros || 0,
          numApprovedBuys: acc.numApprovedBuys || 0,
          sumApprovedBuysInEuros: acc.sumApprovedBuysInEuros || 0,
        };

        if (val.operation === 'buy' && val.status === 'approved') {
          state.numApprovedBuys += 1;
          state.sumApprovedBuysInEuros = new Big(state.sumApprovedBuysInEuros)
            .add(amountInEur)
            .toString();
        } else if (val.operation === 'sell' && val.status === 'approved') {
          state.numApprovedSells += 1;
          state.sumApprovedSellsInEuros = new Big(state.sumApprovedSellsInEuros)
            .add(amountInEur)
            .toString();
        }

        return state;
      }, {});
      return {
        title: 'Page\'s Totals',
        data: [
          {
            ...summary,
            sumApprovedSellsInEuros: formatterCurrency(summary.sumApprovedSellsInEuros, { decimals: 2 }),
            sumApprovedBuysInEuros: formatterCurrency(summary.sumApprovedBuysInEuros, { decimals: 2 }),
            numberOfPurchases: formatterNumber(summary.numberOfPurchases),
            numApprovedSells: formatterNumber(summary.numApprovedSells),
            numApprovedBuys: formatterNumber(summary.numApprovedBuys),
          },
        ]
      };
    },
  },

  otcOrder: {
    additionalColumns: (data) => {
      setAssets();

      let amountInEur = null;
      if (
        data.operation === 'sell' &&
        data.amount !== null &&
        data['rate'] !== null
      ) {
        amountInEur =
          new Big(data.amount)
            .div(new Big(data['rate']))
      }
      else if (data.operation === 'buy' && data.amount !== null) {
        amountInEur =
          new Big(data.amount);
      }
      return {
        amountInEur: amountInEur,
        userId: data['user'],
        walletId: data['wallet'],
        "assetId": data['asset'],
        "asset.symbol": assets && data['asset'] && assets[data['asset']] ? assets[data['asset'].toString()]['symbol'] : data['asset'],
      };
    },
    additionalTable: (data) => {
      const summary = data.reduce((acc, val) => {
        let amountInEur = new Big(0);
        if (
          val.operation === 'sell' &&
          val.amount !== null &&
          val.rate !== null
        )
          amountInEur = new Big(val.amount).div(new Big(val.rate));
        else if (val.operation === 'buy' && val.amount !== null)
          amountInEur = new Big(val.amount);

        // amountInEur = amountInEur.round(decimalPlaces, roundingMode).toString();

        const state = {
          numberOfOtcOrder: data.length || 0,
          numApprovedSells: acc.numApprovedSells || 0,
          sumApprovedSellsInEuros: acc.sumApprovedSellsInEuros || 0,
          numApprovedBuys: acc.numApprovedBuys || 0,
          sumApprovedBuysInEuros: acc.sumApprovedBuysInEuros || 0,
        };

        if (val.operation === 'buy' && val.status === 'approved') {
          state.numApprovedBuys += 1;
          state.sumApprovedBuysInEuros = new Big(state.sumApprovedBuysInEuros)
            .add(amountInEur)
            .toString();
        } else if (val.operation === 'sell' && val.status === 'approved') {
          state.numApprovedSells += 1;
          state.sumApprovedSellsInEuros = new Big(state.sumApprovedSellsInEuros)
            .add(amountInEur)
            .toString();
        }

        return state;
      }, {});
      return {
        title: 'Page\'s Totals',
        data: [
          {
            ...summary,
            sumApprovedSellsInEuros: formatterCurrency(summary.sumApprovedSellsInEuros, { decimals: 2 }),
            sumApprovedBuysInEuros: formatterCurrency(summary.sumApprovedBuysInEuros, { decimals: 2 }),
            numberOfOtcOrder: formatterNumber(summary.numberOfOtcOrder),
            numApprovedSells: formatterNumber(summary.numApprovedSells),
            numApprovedBuys: formatterNumber(summary.numApprovedBuys),
          },
        ]
      };
    },
  },

  userStat: {
    chart: (data) => {
      const series = [
        {
          name: 'Total',
          type: 'line',
          data: [],
        },

        {
          name: 'New',
          type: 'line',
          data: [],
        },
        {
          name: 'Active Total',
          type: 'line',
          data: [],
        },

        {
          name: 'Active New',
          type: 'line',
          data: [],
        },
      ];

      data.forEach((a) => {
        let date = 'N/A';
        let serie1 = 0;
        let serie2 = 0;
        let serie3 = 0;
        let serie4 = 0;
        try {
          date = formatterDate(a.date);;
        } catch (err) { }
        try {
          serie1 = new Big(a.total).toNumber();
        } catch (err) { }
        try {
          serie2 = new Big(a.new).toNumber();
        } catch (err) { }
        try {
          serie3 = new Big(a.active).toNumber();
        } catch (err) { }
        try {
          serie4 = new Big(a.activeNew).toNumber();
        } catch (err) { }
        series[0].data.push([date, serie1]);
        series[1].data.push([date, serie2]);
        series[2].data.push([date, serie3]);
        series[3].data.push([date, serie4]);
      });
      return {
        options: {
          chart: {
            style: {
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
            }
          },
          title: {
            text: 'Users',
          },
          series: series,
          xAxis: {
            title: 'Date',
            tickInterval: 1,
            labels: {
              enabled: true,
              formatter: function () {
                return series[0].data[this.value][0];
              },
            },
          },
          tooltip: {
            shared: true,
            split: false,
            enabled: true,
          },
        },
      };
    },
  },

  walletStat: {
    additionalColumns: (data) => {
      setAssets();
      return {
        "asset.symbol": assets && data['asset'] && assets[data['asset']] ? assets[data['asset'].toString()]['symbol'] : data['asset'],
      };
    },
  },

  purchaseStat: {
    additionalColumns: (data) => {
      setAssets();
      return {
        "asset.symbol": assets && data['asset'] && assets[data['asset']] ? assets[data['asset'].toString()]['symbol'] : data['asset'],
      };
    },
  },
  walletGlobalStat: {
    additionalColumns: (data) => {
      setAssets();
      return {
        "asset.symbol": assets && data['asset'] && assets[data['asset']] ? assets[data['asset'].toString()]['symbol'] : data['asset'],
        "aum": data['AuM'],
        "aumEUR": data['AuM'] && data['rateEUR'] ? new Big(data['AuM']).mul(new Big(data['rateEUR'])).toString() : 0,
      };
    },
    additionalTable: (data) => {
      const summary = data.reduce((acc, val) => {

        const state = {
          totalAum: acc.totalAum || 0,
          totalAumEUR: acc.totalAumEUR || 0,
        };

        state.totalAumEUR = new Big(state.totalAumEUR)
          .add(new Big(val.aumEUR ? val.aumEUR : 0))
          .toString();

        state.totalAum = new Big(state.totalAum)
          .add(new Big(val.aum ? val.aum : 0))
          .toString();


        return state;
      }, {});
      return {
        title: 'Page\'s Totals',
        data: [
          {
            ...summary,
            totalAum: formatterNumber(summary.totalAum, { decimals: 4 }),
            totalAumEUR: formatterCurrency(summary.totalAumEUR, { decimals: 2 }),
          },
        ]
      };
    },
    chart: (data) => {
      setAssets();

      const series = [];
      const assetSerie = {};
      const dates = [];
      data.forEach((stat) => {
        let date = '';
        let asset = '';
        let aumEUR = 0;
        try {
          date = formatterDate(stat.date);;
          aumEUR = new Big(stat.aumEUR ? stat.aumEUR : 0).toNumber();
          asset = stat.asset.toString();
        } catch (err) { }

        if (!assetSerie.hasOwnProperty(asset)) {
          series.push(
            {
              name: assets[asset]['symbol'],
              type: 'column',
              data: [],
              stacking: 'normal'
            }
          );
          assetSerie[asset] = series.length - 1;
        }

        if (!dates.includes(date)) {
          dates.push(date);
        }

        series[assetSerie[asset]].data.push(aumEUR);
      });

      return {
        options: {
          chart: {
            renderTo: "container",
            style: {
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
            }
          },
          title: {
            text: 'Assets under Management',
          },
          series: series,
          xAxis: {
            title: {
              text: 'Dates'
            },
            categories: dates
          },
          yAxis: {
            title: {
              text: 'Euros'
            }
          },
          tooltip: {
            shared: false,
            split: false,
            enabled: true,
            formatter: function () {
              let thisPoint = this.point,
                allSeries = this.series.chart.series,
                thisIndex = thisPoint.index,
                returnString = '<b>Date:</b> ' + this.x + '<br/><br/>';

              allSeries.forEach(function (ser) {
                if (ser.options.stack === thisPoint.series.options.stack) {
                  returnString += ser.name + ': ' + formatterCurrency(ser.points[thisIndex].y, { decimals: 2 }) + '<br/>';
                }
              });

              returnString += '<br/>Total: ' + formatterCurrency(this.point.stackTotal, { decimals: 2 });

              return returnString;
            }
          },
        },
      }
    }
  },
  walletGlobalStatPerAsset: {
    additionalColumns: (data) => {
      setAssets();
      return {
        "asset.symbol": assets && data['asset'] && assets[data['asset']] ? assets[data['asset'].toString()]['symbol'] : data['asset'],
        "Aum": data['AuM'],
        "aumEUR": data['AuM'] && data['rateEUR'] ? new Big(data['AuM']).mul(new Big(data['rateEUR'])).toString() : 0,
      };
    },
    additionalTable: (data) => {
      const summary = data.reduce((acc, val) => {

        const state = {
          totalAum: acc.totalAum || 0,
          totalAumEUR: acc.totalAumEUR || 0,
        };

        state.totalAumEUR = new Big(state.totalAumEUR)
          .add(new Big(val.aumEUR ? val.aumEUR : 0))
          .toString();

        state.totalAum = new Big(state.totalAum)
          .add(new Big(val.Aum ? val.Aum : 0))
          .toString();


        return state;
      }, {});
      return {
        title: 'Page\'s Totals',
        data: [
          {
            ...summary,
            totalAum: formatterNumber(summary.totalAum, { decimals: 4 }),
            totalAumEUR: formatterCurrency(summary.totalAumEUR, { decimals: 2 }),
          },
        ]
      };
    },
  },
  transactionStatPerAsset: {
    additionalColumns: (data) => {
      setAssets();
      return {
        "asset.symbol": assets && data['asset'] && assets[data['asset']] ? assets[data['asset'].toString()]['symbol'] : data['asset'],
        "totalAmountEUR": data['totalAmountEUR'],
      };
    },
    additionalTable: (data) => {
      const totalTransactions = new Array(movementsTransactionStats.length).fill(0);
      //const uniqueUsers = new Array(movementsTransactionStats.length).fill(0);
      const totalAmount = new Array(movementsTransactionStats.length).fill(0);
      const totalAmountEUR = new Array(movementsTransactionStats.length).fill(0);
      // const max = new Array(movementsTransactionStats.length).fill(0); 

      const movements = {};
      movementsTransactionStats.forEach((movement, index) => movements[movement] = index);

      data.forEach(stat => {
        const typeMovement = movements[stat.movement];
        totalTransactions[typeMovement] = new Big(totalTransactions[typeMovement] ? totalTransactions[typeMovement] : 0).add(new Big(stat.totalTransactions ? stat.totalTransactions : 0));
        // uniqueUsers[typeMovement] += new Big(stat.uniqueUsers).toNumber();
        totalAmount[typeMovement] = new Big(totalAmount[typeMovement] ? totalAmount[typeMovement] : 0).add(new Big(stat.totalAmount ? stat.totalAmount : 0));
        // const maxValue = new Big(stat.max);
        // max[typeMovement] = max[typeMovement] < maxValue ? maxValue : max[typeMovement];
        totalAmountEUR[typeMovement] = new Big(totalAmountEUR[typeMovement] ? totalAmountEUR[typeMovement] : 0).add(new Big(stat.amountEur ? stat.amountEur : 0));
      });

      const aggregatedStats = [];
      for (var i = 0; i < movementsTransactionStats.length; i++) {
        aggregatedStats.push({
          movement: movementsTransactionStats[i].toString(),
          totalTransactions: totalTransactions[i].toString(),
          // totalUniqueUsers: uniqueUsers[i],
          totalAmount: formatterNumber(totalAmount[i].toString(), { decimals: 4 }),
          totalAmountEUR: formatterCurrency(new Big(totalAmountEUR[i]).toString(), { decimals: 2 }),
          // max: max[i],
        });
      }

      return {
        title: 'Page\'s Totals',
        data: aggregatedStats
      };
    },
  },
  transactionStat: {
    additionalColumns: (data) => {
      setAssets();
      return {
        "options": 'Details',
        "asset.symbol": assets && data['asset'] && assets[data['asset']] ? assets[data['asset'].toString()]['symbol'] : data['asset'],
        "totalAmountEUR": data['totalAmountEUR'],
      };
    },
    additionalTable: (data) => {
      const totalTransactions = new Array(movementsTransactionStats.length).fill(0);
      //const uniqueUsers = new Array(movementsTransactionStats.length).fill(0);
      const totalAmount = new Array(movementsTransactionStats.length).fill(0);
      const totalAmountEUR = new Array(movementsTransactionStats.length).fill(0);
      // const max = new Array(movementsTransactionStats.length).fill(0); 

      const movements = {};
      movementsTransactionStats.forEach((movement, index) => movements[movement] = index);

      data.forEach(stat => {
        const typeMovement = movements[stat.movement];
        totalTransactions[typeMovement] = new Big(totalTransactions[typeMovement] ? totalTransactions[typeMovement] : 0).add(new Big(stat.totalTransactions ? stat.totalTransactions : 0));
        // uniqueUsers[typeMovement] += new Big(stat.uniqueUsers).toNumber();
        totalAmount[typeMovement] = new Big(totalAmount[typeMovement] ? totalAmount[typeMovement] : 0).add(new Big(stat.totalAmount ? stat.totalAmount : 0));
        // const maxValue = new Big(stat.max);
        // max[typeMovement] = max[typeMovement] < maxValue ? maxValue : max[typeMovement];
        totalAmountEUR[typeMovement] = new Big(totalAmountEUR[typeMovement] ? totalAmountEUR[typeMovement] : 0).add(new Big(stat.amountEur ? stat.amountEur : 0));
      });

      const aggregatedStats = [];
      for (var i = 0; i < movementsTransactionStats.length; i++) {
        aggregatedStats.push({
          movement: movementsTransactionStats[i].toString(),
          totalTransactions: totalTransactions[i].toString(),
          // totalUniqueUsers: uniqueUsers[i],
          totalAmount: formatterNumber(totalAmount[i].toString(), { decimals: 4 }),
          totalAmountEUR: formatterCurrency(new Big(totalAmountEUR[i]).toString(), { decimals: 2 }),
          // max: max[i],
        });
      }

      return {
        title: 'Page\'s Totals',
        data: aggregatedStats
      };
    },
    chart: (data) => {
      setAssets();

      const series = [];
      const movementAssetSerie = {};
      const dates = [];
      const assetsProcessed = [];
      data.forEach((stat) => {
        let date = '';
        let movement = '';
        let amountEur = 0;
        let asset = '';
        let symbol = '';
        try {
          date = formatterDate(stat.date);
          movement = stat.movement.toString();
          amountEur = new Big(stat.amountEur ? stat.amountEur : 0).toNumber();
          asset = stat.asset.toString();
          symbol = assets[asset]['symbol'];
        } catch (err) { }

        if (!dates.includes(date)) {
          dates.push(date);
        }

        if (!movementAssetSerie.hasOwnProperty(symbol + movement)) {
          const newSerie = {
            name: symbol,
            data: [amountEur],
            stack: movement,
            stacking: 'normal'
          }
          if (!assetsProcessed.includes(symbol)) {
            assetsProcessed.push(symbol);
            newSerie['id'] = symbol;
          } else {
            newSerie['linkedTo'] = symbol;
          }
          series.push(newSerie);
          movementAssetSerie[symbol + movement] = series.length - 1;
        } else {
          series[movementAssetSerie[symbol + movement]].data.push(amountEur);
        }
      });
      return {
        options: {
          chart: {
            type: 'column',
            renderTo: "container",
            style: {
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
            }
          },
          title: {
            text: 'Transaction Stats',
          },
          series: series,
          xAxis: {
            title: {
              text: 'Dates'
            },
            categories: dates
          },
          yAxis: {
            title: {
              text: 'Euros'
            }
          },
          tooltip: {
            shared: false,
            split: false,
            enabled: true,
            formatter: function () {
              let thisPoint = this.point,
                allSeries = this.series.chart.series,
                stackName = this.series.userOptions.stack,
                thisIndex = thisPoint.index,
                returnString = '<b>Movement:</b> ' + stackName + '<br/><br/><b>Date:</b> ' + this.x + '<br/><br/>';

              allSeries.forEach(function (ser) {
                if (ser.options.stack === thisPoint.series.options.stack) {
                  returnString += ser.name + ': ' + formatterCurrency(ser.points[thisIndex].y, { decimals: 2 }) + '<br/>';
                }
              });

              returnString += '<br/><b>Total:</b> ' + formatterCurrency(this.point.stackTotal, { decimals: 2 });

              return returnString;
            }
          },
        },
      }
    },
  },
};

